<template>
  <v-col class="col-12">
    <v-container fill-height>
      <v-row no-gutters align="center">
        <span class="title">Content Maintenance</span>
      </v-row>
      <v-row>
        <v-col cols="3" xs="6" sm="6" md="3" lg="3" xl="3">
          <g-add-card
            ref="addCard"
            header="Add Content"
            subHeader="Click here to add a new Content Item"
          >
            <template v-slot:back-card="{ flipBack }">
              <v-col>
                <span class="title" style="color: white"
                  >Create New Content</span
                >
                <v-text-field
                  ref="focusField"
                  class="mt-5"
                  dark
                  dense
                  outlined
                  label="Title"
                  v-model="createItem.title"
                >
                </v-text-field>
                <v-spacer></v-spacer>
              </v-col>
              <v-btn dense class="mb-0" small block rounded @click="create()"
                >create</v-btn
              >
              <v-btn dense class="mb-0" small block rounded @click="flipBack()"
                >cancel</v-btn
              >
           
            </template>
          </g-add-card>
        </v-col>
        <v-col
          cols="3"
          xs="6"
          sm="6"
          md="3"
          lg="3"
          xl="3"
          v-for="(item, idx) in controller.list"
          :key="idx"
          style="text-align: center; text-justify: center"
        >
          <g-list-card
            :item="item"
            :header="item.title"
            :onImageClick="routeToItem"
            :addContentTt="addContentTt"
            :editTt="editTt"
            :deleteTt="deleteTt"
            controller="content"
          >
          </g-list-card>
        </v-col>
      </v-row>
    </v-container>


    <confirmation-dialog ref="confirmationDialog" />
  </v-col>
</template>
<script>
export default {
  data() {
    return {
      controller:this.get_controller("content"),
      addContentTt: "Add Content",
      editTt: "Edit Content",
      deleteTt: "Delete Content",
      createItem: {
        title: "",
      },
    };
  },
  computed: {
    backCardFlipped() {
      let self = this;
      return self.$refs.addCard.flipped;
    },
  },
  mounted() {
    let self = this;
    this.$watch("backCardFlipped", self.watchBackCardFlipped);
  },
  methods: {
    watchBackCardFlipped(newItem) {
      let self = this;
      if (newItem == true) {
        self.$nextTick(() => {
          self.$refs.focusField.focus();
        });
      }
    },
    create() {
      let self = this;
      self.postContentPage(self.createItem);
      self.$refs.addCard.flipBack();
    },
    routeToItem(item) {
      let self = this;
      self.$router.push("content/page/" + item.id);
    },
    postContentPage(request) {
      let self = this;
      self
        .post(`Content`, request)
        .then((r) => {
          if (r.data.success) {
            self.routeToItem(r.data.data);
          }
          console.log(r.data);
        })
        .catch((err) => {
          console.error("Something went wrong Creating content page", err);
        });
    },
  },
};
</script>